import {
  acceptWish,
  getWishById,
  rejectWish,
  sendOffer,
} from "../../services/wish.api";

export const fetchWishDetails = (wishId) => getWishById(wishId);

/**
 * The offer log lives on the wish itself now — there is no separate
 * negotiations endpoint — so this reads the same document.
 */
export const fetchWishNegotiations = async (wishId) => {
  const wish = await getWishById(wishId);
  return wish?.negotiations || [];
};

export const sendBuyerNegotiation = (wishId, price) => sendOffer(wishId, price);

/**
 * The API has explicit accept/reject actions rather than a status write.
 * A customer withdrawing their own wish is the same "reject" call.
 */
export const updateWishOrderStatus = (wishId, status) => {
  const next = String(status || "").toLowerCase();
  if (next === "accepted") return acceptWish(wishId);
  if (next === "rejected" || next === "cancelled") return rejectWish(wishId);
  return Promise.reject(new Error(`Unsupported wish action: ${status}`));
};

export { orderFromWish } from "../../services/wish.api";
